import { blogPosts } from '../../../mocks/blog';

export default function Blog() {
  return (
    <section id="blog" className="py-16 sm:py-20 md:py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
            花藝知識分享
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            探索花藝世界的美好，學習專業的花卉保養與搭配技巧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative overflow-hidden h-56 sm:h-64 w-full">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-[#14B8A6] text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold">
                  {post.category}
                </div>
              </div>

              <div className="p-5 sm:p-6">
                <div className="flex items-center gap-4 text-xs sm:text-sm text-gray-500 mb-3 sm:mb-4">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line"></i>
                    {post.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    {post.readTime}
                  </span>
                </div>

                <h3 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-2 sm:mb-3 group-hover:text-[#14B8A6] transition-colors duration-300">
                  {post.title}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-5 line-clamp-2 leading-relaxed">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-xs sm:text-sm text-[#14B8A6] font-semibold group-hover:underline">
                    閱讀更多 →
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
